import visit from '@/api/customer/visitation'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { join } from 'lodash'

export const state = {
  ...baseState,
  salers: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  provinces: undefined
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SALE(state, data){
    state.salers = data
  },
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_SET_PROVINCE(state, date){
    state.provinces = date
  },
  CLEAR_SETUP(state){
    state.salers = []
    state.customers = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        search: context.state.search,
        date_from: context.state.dateRange[0],
        date_to: context.state.dateRange[1],
        provinces: context.state.provinces ? join(context.state.provinces, '^') : ''
      },
      attrubutes
    )
    return visit.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return visit.store(data)
  },
  update(context, { id, data }) {
    return visit.update(id, data)
  },
  destroy(context, id){
    return visit.destroy(id)
  },
  show(context, id){
    return visit.show(id)
  },
  // async fetchResources(context){
  //   let sale = await visit.user()
  //     context.commit('SET_SALE', sale.data)
  // },
  // getCustomer(context, arrtributes = {}){
  //   return visit.customer({ params: arrtributes })
  // }
  getCommuneInDistrict(context, payload){
     return visit.getCommuneInDistrict(payload)
  },
  getShop(context, payload){
     return visit.getShop(payload)
  },
  getFormViewModel(context, attributes = {}){
    return visit.formViewModel({ params: attributes })
  }
}
